module.exports = __webpack_public_path__ + "images/store_case_study/mlmkaitoricocotop-pic2_de9775406eaf643bec961eeed80b271e.jpg";